module.exports = __webpack_public_path__ + "static/media/list_white.d3014369.svg";